// @ngInject
function CreateVariantDeliveryDateDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(fulfillableProduct, selectedWarehouse, minimumAvailableStock) {

        var modalDefaults = {
            backdrop: 'static', //true, false, static
            keyboard: true,
            controller: 'CreateVariantDeliveryDateDialogServiceController as vm',
            templateUrl:'main/resellerorder/resellerorderfulfillment/createfulfillment/components/DeliveryDateDialog/createVariantDeliveryDateDialog.tpl.html',
            size: 'super'
        };

        modalDefaults.resolve = {
            fulfillableProduct: function() {
                return fulfillableProduct;
            },
            selectedWarehouse: function() {
                return selectedWarehouse;
            },
            minimumAvailableStock: function() {
                return minimumAvailableStock;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function CreateVariantDeliveryDateDialogServiceController($uibModalInstance, fulfillableProduct, selectedWarehouse, minimumAvailableStock) {
    var vm = this;

    //Properties
    vm.fulfillableProduct = fulfillableProduct;
    vm.selectedWarehouse = selectedWarehouse;
    vm.minimumAvailableStock = minimumAvailableStock;

    //Methods
    vm.closeModal = closeModal;
    vm.fulfillmentApplied = fulfillmentApplied;

    function closeModal(args) {
        $uibModalInstance.close(args);
    }

    function fulfillmentApplied(itemsToFulfill) {
        vm.closeModal({ success: true, itemsToFulfill: itemsToFulfill });
    }
}

angular
    .module('services.dialogs.createVariantDeliveryDateDialogService', [])
    .service('CreateVariantDeliveryDateDialogService', CreateVariantDeliveryDateDialogService)
    .controller('CreateVariantDeliveryDateDialogServiceController', CreateVariantDeliveryDateDialogServiceController);
